import { render, staticRenderFns } from "./CampaignData.vue?vue&type=template&id=6ae3a342&"
import script from "./CampaignData.vue?vue&type=script&lang=js&"
export * from "./CampaignData.vue?vue&type=script&lang=js&"
import style0 from "./CampaignData.vue?vue&type=style&index=0&id=6ae3a342&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports